module.exports = __webpack_public_path__ + "static/media/welcome.740e8bbb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/projects/elavon/src/welcome.jpg
// module id = 586
// module chunks = 0